$(document).on('mouseenter', 'div[data-catalog-flag]', (event) => {
  $(event.currentTarget).children(':last-child').fadeIn(100);
  $(event.currentTarget).parent().css('width', '50%');
});

$(document).on('mouseleave', 'div[data-catalog-flag]', (event) => {
  $(event.currentTarget).children(':last-child').fadeOut(100);
  $(event.currentTarget).parent().css('width', '30px');
});
